import { render, staticRenderFns } from "./UpdateLevel.vue?vue&type=template&id=270314eb&scoped=true"
import script from "./UpdateLevel.vue?vue&type=script&lang=js"
export * from "./UpdateLevel.vue?vue&type=script&lang=js"
import style0 from "./UpdateLevel.vue?vue&type=style&index=0&id=270314eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270314eb",
  null
  
)

export default component.exports